import {
  TRANSACTION_PROTOCOL_TYPE_FETCH_REQUEST,
  TRANSACTION_PROTOCOL_TYPE_FETCH_REQUEST_SUCCESS,
  TRANSACTION_PROTOCOL_TYPE_FETCH_REQUEST_FAILURE,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */

const channelProtocolTypesReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TRANSACTION_PROTOCOL_TYPE_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TRANSACTION_PROTOCOL_TYPE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case TRANSACTION_PROTOCOL_TYPE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    default:
      return state;
  }
};

export default channelProtocolTypesReducer;
